import Model from 'flarum/common/Model';
/**
 * A reader comment on an article. `content` is the raw markdown source (used to
 * pre-fill the editor); `contentHtml` is the rendered output.
 */
export default class WikiComment extends Model {
  content = (() => Model.attribute('content'))();
  contentHtml = (() => Model.attribute('contentHtml'))();
  canEdit = (() => Model.attribute('canEdit'))();
  canDelete = (() => Model.attribute('canDelete'))();
  isDeleted = (() => Model.attribute('isDeleted'))();
  createdAt = (() => Model.attribute('createdAt', Model.transformDate))();
  updatedAt = (() => Model.attribute('updatedAt', Model.transformDate))();
  deletedAt = (() => Model.attribute('deletedAt', Model.transformDate))();
  user = (() => Model.hasOne('user'))();
  article = (() => Model.hasOne('article'))();
}
flarum.reg.add('linkrobins-wiki', 'common/models/WikiComment', WikiComment);